import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiService } from '../../../api/apiClient';
import AuditFiltersBar from '../AuditFiltersBar';
import AuditTable, { statusPill, formatTs, monoShort } from '../AuditTable';
import InfoBox from '../InfoBox';
import useAuditList from '../useAuditList';

export default function MutationsTab({ onOpenTrace }) {
  const { t } = useTranslation();
  const { rows, loading, filters, setFilters, offset, limit, next, prev } =
    useAuditList(apiService.listAuditMutations);

  const columns = [
    { key: 'timestamp', header: t('traceability:columns.timestamp'), render: (r) => formatTs(r.timestamp) },
    { key: 'kind', header: t('traceability:columns.kind'),
      render: (r) => (r._labels || []).includes('RelationshipMutation') ? 'rel' : 'node' },
    { key: 'op', header: t('traceability:columns.op') },
    { key: 'label', header: t('traceability:columns.label'),
      render: (r) => r.label || r.rel_type || '—' },
    { key: 'merge_key', header: t('traceability:columns.mergeKey'),
      render: (r) => r.merge_key || r.src_ref || '—' },
    { key: 'merge_value', header: t('traceability:columns.mergeValue'),
      render: (r) => r.merge_value || r.tgt_ref || '—' },
    { key: 'status', header: t('traceability:columns.status'), render: (r) => statusPill(r.status) },
    { key: 'trace_id', header: t('traceability:columns.traceId'),
      render: (r) => <button onClick={(e) => { e.stopPropagation(); onOpenTrace(r.trace_id); }}
                             className="hover:text-accent-text">{monoShort(r.trace_id, 10)}</button> },
  ];

  return (
    <div>
      <InfoBox tabKey="mutations" />
      <AuditFiltersBar value={filters} onChange={setFilters} />
      <AuditTable rows={rows} columns={columns} loading={loading}
                  limit={limit} offset={offset} onNext={next} onPrev={prev}
                  onRowClick={(r) => onOpenTrace(r.trace_id)} />
    </div>
  );
}
